import classNames from 'classnames';
import { useCallback, VoidFunctionComponent } from 'react';
import { useDispatch } from 'react-redux';
import { Button } from 'react-bootstrap';
import { bootstrapUtils } from 'react-bootstrap/lib/utils';

import Flex from '../../generic/Flex';
import type { ReduxAction } from '../../../types';

bootstrapUtils.addStyle(Button, 'filter');

type RangedToggleProps = {
  filterEnabled: boolean;
  range: { min: number; max: number };
  toggleFilter: () => Pick<ReduxAction, 'type'>;
  setRange: (min: number, max: number) => Pick<ReduxAction, 'type'>;
  text: string;
};

const RangedToggle: VoidFunctionComponent<RangedToggleProps> = ({
  filterEnabled,
  range,
  toggleFilter,
  setRange,
  text,
}) => {
  const dispatch = useDispatch();

  const onChangeMin = useCallback((e) => {
    dispatch(setRange(e.target.value, range.max));
  }, [range.max, setRange, dispatch]);

  const onChangeMax = useCallback((e) => {
    dispatch(setRange(range.min, e.target.value));
  }, [range.min, setRange, dispatch]);

  return (
    <div className="contributor-count-area">
      <div className="range-toggle-button">
        <Button
          bsStyle={classNames({
            filter: true,
            selected: filterEnabled,
          })}
          onClick={() => dispatch(toggleFilter())}
          style={{ margin: 15 }}
        >
          {text}
        </Button>
      </div>
      {/* TODO Change these inputs to be our LabeledNumberInput component after NumberInput typings have been fixed. */}
      <Flex direction="column">
        <p>
          <span className="range-toggle-label">min:</span>
          <input type="number" value={range.min} onChange={onChangeMin} />
        </p>
        <p>
          <span className="range-toggle-label">max:</span>
          <input type="number" value={range.max} onChange={onChangeMax} />
        </p>
      </Flex>
    </div>
  );
};

export default RangedToggle;
